import { action, observable } from 'mobx';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { PatientInsuranceEditModalForm } from 'application/facility-order/forms';
import { InsuranceService } from 'application/import-reference/services';
import { PatientService } from "application/patient/services";

class PatientInsuranceEditModalViewStore extends BaseEditViewStore {
    @observable accessor patientInsuranceInfo = null;
    @observable accessor primaryInsurance = null;
    @observable accessor secondaryInsurance = null;
    @observable accessor oldPrimaryInsuranceDisplayed = false;  
    @observable accessor patient = null;
           
    constructor(rootStore, componentProps) {
        const insuranceService = new InsuranceService(rootStore.application.baasic.apiClient);
        const patientService = new PatientService(rootStore.application.baasic.apiClient);

        const patientKey = componentProps.modalParams.data.patientKey;

        super(rootStore, {
            name: 'patient-insurance-edit-modal',
            Form: PatientInsuranceEditModalForm,
            id: patientKey,
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await patientService.get(id);
                        this.patient = response.data;
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await patientService.updatePatientInsurance(resource);
                        await this.refreshPatientData(this.patientKey);
                        this.refreshTemplatesData();
                        return response;
                    }
                }
            },
            FormClass: PatientInsuranceEditModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.refreshPatientData = componentProps.modalParams.data.refreshPatientData;
        this.refreshTemplatesData = componentProps.modalParams.data.refreshTemplatesData;

        this.insuranceService = insuranceService;
        this.patientKey = patientKey;

        this.primaryInsuranceStore = this.constructInsuranceDropdownStore('primary');
        this.oldPrimaryInsuranceStore = this.constructInsuranceDropdownStore('oldPrimary');
        this.secondaryInsuranceStore = this.constructInsuranceDropdownStore('secondary');
    }

    @action.bound
    toggleOldPrimaryInsurance() {
        if(this.oldPrimaryInsuranceDisplayed){
            this.form.$('oldPrimaryInsuranceName').value = null;
            this.form.$('oldPrimaryInsurancePolicyNumber').value = null;            
            this.form.$('oldPrimaryInsuranceStartDate').value = null;
            this.form.$('oldPrimaryInsuranceEndDate').value = null;

            this.form.$('oldPrimaryInsurancePolicyNumber').set('rules', null);
            this.form.$('oldPrimaryInsuranceStartDate').set('rules', null);
            this.form.$('oldPrimaryInsuranceEndDate').set('rules', null);            
        
            this.oldPrimaryInsuranceDisplayed = false;            
        } else {
            this.oldPrimaryInsuranceDisplayed = true;
        }
    }

    @action.bound
    getDate(date, dateToAdd = 0) {
        var result = new Date(new Date(date).setHours(12, 0, 0, 0));
        result.setDate(result.getDate() + dateToAdd);
        return result;
    }

    @action.bound
    constructInsuranceDropdownStore(prefix) {
        return new BaasicDropdownStore({
            textField: 'name',
            dataItemKey: 'name',
            filterable: true            
        }, {
        fetchFunc: async (term) => {
            const response = await this.insuranceService.find({ searchQuery: term, rpp:50,sort:"name|asc" });
            return response.data.item;
        },
        onChange: (insurance) => {
            if (insurance)
            {
                this.form.$(prefix + 'InsurancePolicyNumber').set('rules', 'required');
                this.form.$(prefix + 'InsuranceStartDate').set('rules', 'required');

                this.form.$(prefix + 'InsuranceStartDate').value = 
                (prefix === "primary" && this.primaryInsurance && this.primaryInsurance.payorPolicyInfo) ?  this.getDate(this.primaryInsurance.payorPolicyInfo.effectiveDate, 1) : 
                (prefix === "secondary" && this.secondaryInsurance && this.secondaryInsurance.payorPolicyInfo) ? this.getDate(this.secondaryInsurance.payorPolicyInfo.effectiveDate, 1) : this.getDate('1980-01-01');

                if (prefix == 'oldPrimary')
                    this.form.$(prefix + 'InsuranceEndDate').set('rules', 'required'); 
            }
        }
        });
    }

    @action.bound
    isValidDate(resource) {
        if(this.primaryInsurance && this.primaryInsurance.payorPolicyInfo && resource.primaryInsuranceStartDate !== "" && resource.primaryInsuranceStartDate <= this.getDate(this.primaryInsurance.payorPolicyInfo.effectiveDate)){
            return false;
        }

        if(this.secondaryInsurance && this.secondaryInsurance.payorPolicyInfo && resource.secondaryInsuranceStartDate !== "" && resource.secondaryInsuranceStartDate <= this.getDate(this.secondaryInsurance.payorPolicyInfo.effectiveDate)) {
            return false;
        }

        return true;
    }
        
    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            if (!this.isValidDate(resource)){
                this.form.setFieldsDisabled(false);
                await setTimeout(() => this.rootStore.notificationStore.warning("New Start Date must be greater than the old Start Date"), 10);
                return;
            } 

            await this.actions.update({
                patientBrightreeId: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            this.modalParams.close();
            await setTimeout(() => this.rootStore.notificationStore.success("TEMPLATES.PATIENT_INSURANCE.EDIT"));
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default PatientInsuranceEditModalViewStore;
